import { HeaderService } from './header.service';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ResultData } from '../_models/ResultData';

@Injectable({
  providedIn: 'root'
})
export class FactService {


  constructor(
    private http: HttpClient,
    private headerService:HeaderService) {}

 addFactsToSubTopic(formData:string):Observable<ResultData>{
  const hh = this.headerService.bearerFormHeaders()
      return this.http.post<ResultData>(`${environment.apiUrl}/subTopic/addFacts`, formData,{headers:hh})

    }
    editFact(formData:string):Observable<ResultData>{
      const hh = this.headerService.bearerFormHeaders()
      return this.http.post<ResultData>(`${environment.apiUrl}/fact/factEdit`, formData,{headers:hh})
    }
      getFactBookItem(id:number):Observable<ResultData>{
        const hh = this.headerService.bearerJsonHeaders()
        return this.http.get<ResultData>(`${environment.apiUrl}/fact/getitemapi/${id}`,{headers:hh})

      }
    addHoax(factId: number, newHoax: any): Observable<ResultData> {
      const hh = this.headerService.bearerJsonHeaders()
      return this.http.post<ResultData>(`/api/facts/${factId}/hoaxes`, newHoax,{headers:hh});
    }
    removeFact(server_subtopic_id:number,factId:number):Observable<ResultData>{
      const hh = this.headerService.bearerJsonHeaders()
      return this.http.get<ResultData>(`${environment.apiUrl}/subTopic/apiremovefact/${server_subtopic_id}?factId=${factId}`,{headers:hh})

    }

    saveFactTemplate(formData:FormData, server_fact_id:number):Observable<ResultData>{

      let url=`${environment.apiUrl}/fact/saveFactFromTemplate/${server_fact_id}`
      return this.http.post<ResultData>(url, formData, {headers: this.headerService.bearerFormMultipartHeaders()})
    }
    getTopicSyllabusInfo(subTopicId:number):Observable<ResultData>{
      const hh = this.headerService.bearerJsonHeaders()
      return this.http.get<ResultData>(`${environment.apiUrl}/syllabus/syllabusBySubTopic/${subTopicId}`,{headers:hh})

    }

    getFactsBySubTopic(subTopicId:number):Observable<ResultData>{
      const hh = this.headerService.bearerJsonHeaders()
      return this.http.get<ResultData>(`${environment.apiUrl}/subTopic/apifactbooklist/${subTopicId}`,{headers:hh})

    }
    getHoaxList(factId:number):Observable<ResultData>{
      const hh = this.headerService.bearerJsonHeaders()
      return this.http.get<ResultData>(`${environment.apiUrl}/hoax/hoaxListByFact/${factId}`,{headers:hh})

    }


    getFactById(factId:number):Observable<ResultData>{
      const hh = this.headerService.bearerJsonHeaders()
      return this.http.get<ResultData>(`${environment.apiUrl}/fact/factById/${factId}`,{headers:hh})

    }

    getHoaxById(factId:number):Observable<ResultData>{
      const hh = this.headerService.bearerJsonHeaders()
      return this.http.get<ResultData>(`${environment.apiUrl}/hoax/hoaxById/${factId}`,{headers:hh})

    }

    removeHoax(factId:number, hoaxId:number):Observable<ResultData>{
      const hh = this.headerService.bearerJsonHeaders()
      return this.http.get<ResultData>(`${environment.apiUrl}/fact/removeHoax/${factId}/${hoaxId}`,{headers:hh})

    }

     addHoaxesToFact(factId: number,formData:string):Observable<ResultData>{
      const hh = this.headerService.bearerFormHeaders()
          return this.http.post<ResultData>(`${environment.apiUrl}/fact/addHoaxToFact/${factId}`, formData, {headers:hh})

        }
        transferToHoax(factId: number, hoaxId:number): Observable<any> {
          const hh = this.headerService.bearerFormHeaders()
          return this.http.post<ResultData>(`${environment.apiUrl}/fact/transferToHoax/${factId}/${hoaxId}`, {headers:hh});
        }
        getFacts():Observable<ResultData> {
          const hh = this.headerService.bearerJsonHeaders()
            return this.http.get<ResultData>(`${environment.apiUrl}/fact/listAll`,{headers:hh})

          }

  newFactBookItem(formData:string):Observable<ResultData> {
              const hh = this.headerService.bearerFormHeaders()
    return this.http.post<ResultData>(`${environment.apiUrl}/fact/saveFact`, formData, {headers:hh})

}

 getSubTopicByFact(server_fact_id:number):Observable<ResultData>{
    const hh = this.headerService.bearerJsonHeaders()
    return this.http.get<ResultData>(`${environment.apiUrl}/subTopic/subTopicsByFactId/${server_fact_id}`,{headers:hh})
  }
  testFact(server_fact_id:number):Observable<ResultData>{
    const hh = this.headerService.bearerJsonHeaders()
    return this.http.get<ResultData>(`${environment.apiUrl}/fact/testFact/${server_fact_id}`,{headers:hh})
  }

}
